import { ToastContext } from 'common/toast/context'
import { useContext } from 'react'

export function useToast() {
  return useContext(ToastContext)!
}
